export default "__VITE_ASSET__CwUpTnsC__"